module.exports = __webpack_public_path__ + "img/logo.7b740e7b.png";